import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  OnChanges,
  ViewEncapsulation,
  EventEmitter
} from '@angular/core';
import { ICardItem } from '@knz/util';


@Component({
  selector: 'card-item',
  exportAs: 'cardItem',
  templateUrl: './card-item.component.html',
  host: { '[class.card-item]': 'true' },
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CardItemComponent implements AfterViewInit, OnChanges {
  @Input() type: string = "overtime";
  @Input() data: ICardItem[] = [];

  @Output() itemClickEvent = new EventEmitter<any>();
  isopen = false;
  number = 0;
  getcolor(i) {
    this.number +=1;
    if (i % 7==0) {
      this.number = 0;
    }
    return this.number;
  }

  constructor() { }


  ngAfterViewInit() {
  }

  ngOnChanges() {
  }

  cardStatus(){
    this.isopen=!this.isopen; 
  }

  cardClick(item) {
    this.itemClickEvent.emit(item);
  }
}
